import React from 'react';
import parse from 'html-react-parser';
import LazyImage from '../LazyImage';
import './style.css';

const RenderContent = ({ htmlString, applyListFontSizeClass }) => {
    const renderContent = (htmlString) => {
        if (htmlString) {
            return parse(htmlString, {
                replace: (domNode) => {
                    if (domNode.name === 'img' && domNode.attribs.src?.indexOf('servlet/rtaImage') > -1) {
                        return <LazyImage src={domNode.attribs.src} alt={domNode.attribs.alt} />;
                    }
                },
            });
        }
        return '';
    };

    return <div className={`description ${applyListFontSizeClass ? "small-font-number" : ""}`}>{renderContent(htmlString)}</div>;
};

export default RenderContent;
